import React from 'react';
import { Collapse, DropdownItem, DropdownMenu, DropdownToggle, Nav, Navbar, NavbarToggler, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';

import 'bootstrap/dist/css/bootstrap.min.css';
interface IAdminMenu {
    adminUser: AuthAdminUserModel;
    adminPageClickCallback(page: string): void
}

export default function AdminMenu({ adminUser, adminPageClickCallback }: IAdminMenu) {
    function buildSystemMenuButton() {
        return (
            <UncontrolledDropdown nav inNavbar key="systemdropdown">
                <DropdownToggle nav caret size="md" color="outline-primary">System</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("adm-blocks")}>Customer Blocks</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("adm-user-mgt")}>User Management</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("sys-config")}>System Configuration</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown >
        )
    }

    function buildDefaultDataMenuButton() {
        return (
            <UncontrolledDropdown nav inNavbar key="defaultdropdown">
                <DropdownToggle nav caret size="md" color="outline-primary">Default Data</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("data-aircraft")}>Aircraft</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("data-airports")}>Airports</DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("data-report-airports")}>Report Airports</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("data-regions")}>Regions</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown >
        )
    }

    function buildEmailMenuButton() {
        return (
            <UncontrolledDropdown nav inNavbar key="emaildropdown" >
                <DropdownToggle nav caret size="md" color="outline-primary">Email</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("email-templates")}>Email Templates</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("email-customers")}>Send Batch Email To Customers</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("email-awards")}>Send Award Reports</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("email-year-rpt")}>Send End of Year Report</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("adm-templates")}>System Email Templates</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("activation-emails")}>Activation Emails</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown >
        )
    }

    function buildBillingMenuButton() {
        return (
            <UncontrolledDropdown nav inNavbar key="billingdropdown" >
                <DropdownToggle nav caret size="md" color="outline-primary">Billing</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bill-monthly")}>Monthly Billing</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bill-promos")}>Promotions</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }

    function buildBiddingMenuButton() {
        return (
            <UncontrolledDropdown nav inNavbar key="biddingdropdown" >
                <DropdownToggle nav caret size="md" color="outline-primary">Bidding</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-periods")}>Bid Periods</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-packages")}>Bid Packages</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-credit-range")}>Credit Range</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-option-groups")}>Option Groups</DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-options")}>Options</DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("bid-waives")}>Waives</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }

    const [isOpen, setIsOpen] = React.useState(false);
    const toggle = () => setIsOpen(!isOpen);

    function buildQcLink(): React.ReactNode {
        return (
            <UncontrolledDropdown nav inNavbar key="qcdropdown" >
                <DropdownToggle nav caret size="md" color="outline-primary">QC</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("qc-customers")}>QC Customers</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem href="#" onClick={() => adminPageClickCallback("qc-quicknotes")}>QC Quick Notes</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }

    return (
        <React.Fragment>
            <div className="user-admin-buttons">
                <Navbar className="navbar-expand-md">
                    <NavbarToggler onClick={toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="me-auto" navbar>
                            {adminUser?.canDoQC && buildQcLink()}
                            {adminUser?.isAdmin && buildBiddingMenuButton()}
                            {adminUser?.canDoBilling && buildBillingMenuButton()}
                            {adminUser?.canEmail && buildEmailMenuButton()}
                            {adminUser?.isAdmin && buildDefaultDataMenuButton()}
                            {adminUser?.isAdmin && buildSystemMenuButton()}
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        </React.Fragment>
    )
}
